import { Url } from '@42.nl/react-url';

export const ABOUT_URL = '/about';

export function toAbout(): Url {
  return ABOUT_URL;
}
